export interface ReserveRequestModel {
    url: string;
    data: ReserveRequest;
}

interface ReserveRequest {
    pos: string;
    channel: string;
    context: string;
    reservationId: string;
    offerId: string,
    bookingType: string;
    passengers: PassengerInfo;
}

interface PassengerInfo {
    passengerid: PassengerIdWifiData;
}

interface PassengerIdWifiData {
    WIFI: Array<WifiData>;
}

interface WifiData {
    connectionId: string;
    segmentId: string;
    quantitiy: number;
}

export interface CheckoutRequestModel {
    url: string;
    data: CheckoutRequest;
}

interface CheckoutRequest {
    paymentInfo: PaymentInfoData;
}

interface PaymentInfoData {
    creditCard: CreditCardData;
}

interface CreditCardData {
    dcpId: string;
}

export interface SaveCardRequestModel {
    url: string;
    data: SaveCardRequest;
}

interface SaveCardRequest {
    creditCardDetails: Array<CreditCardInfoData>;
}

interface CreditCardInfoData {
    dcpId: string;
    isValidationRequired: string;
}

export class PaymentOptionsInput {
    pos: string;
    context: string;
    channel: string;
    customerId?: string;
    style?: string;
    locale: string;
    apiBaseUrl: string;
    cmpCode?: string;
    isRevenue: boolean;
    cartId: string;
    checkoutId: string;
}

export class PaymentOutput {
    selectedMethod: string;
    selectedGroup: string;
    saveCard: boolean;
    dcpId: string;
    ccFormValid: boolean;
    serviceProvider: string;
    cmpCode: string;
}

export class ConformRequest {
    paymentInfo : PaymentInformation;
}

export class PaymentInformation {
    creditCard : CreditCard;
}

export class CreditCard {
    dcpId : string;
}

export class ConformResponse {
    checkoutId : string;
    pos : string;
    status : string;
    paymentInfo : Array<PaymentInfo>;
    products : Map<string , Array<Product>>;
}

export class Product  {
    productId : string;
    passengerId : string;
    quantity : number;
    status : string;
}

export class PaymentInfo {
    type : string;
    creditCardDetails : CreditCardDetails;
}

export class CreditCardDetails {
    creditCardType : string;
    nameOnCard : string;
    accountNumber : string;
}

export interface PaymentInfo {
    id: string;
    type: string;
    value: number;
    unit: string;
    voucher?: Voucher;
}

export interface Voucher {
    id: string;
    amount: number;
    expiryDate: string;
    balance: number;
    availableToUse: number;
}
